export class NetworkError extends Error {
    constructor(message) {
        super(message);
        this.name = 'NetworkError';
    }
}

export class ApiError extends Error {
    constructor(message) {
        super(message);
        this.name = 'ApiError';
    }
}

export class SentryReportError extends Error {
    constructor(customName, originalError) {
        super('Manual Report');
        this.name = customName; // 使用用户指定的 name
        this.originalError = null;
        this.originalMessage = null;
        this.originalName = null;

        if (originalError) {
            this.originalError = originalError;
            this.originalMessage = originalError.message;
            this.originalName = originalError.name;
            // 保留原始错误的堆栈信息
            this.stack = originalError.stack;
        }
    }
}
